/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import ScrollFadeIn from './../scroll-fade/./scroll-fade';
import WakesurfEdgeSelector from './../wake-shaper-finder/./wake-shaper-finder';

interface IProps {
  title?:string;
  subTitle?:string;
  description?:string;
  icon?:string;
  preTitle?:string;
  backgroundImage?:string;
  backgroundTint?:string;
  height?:string;
  textPlacement?:string;
  theme?:string;
  decorativeText?:boolean;
  wakeShaperFinder?:any;
}

interface IState {
  ready:boolean;
}


/**
 *
 * Hero component
 * @extends {React.Component}
 */
class HosportsHero extends React.Component<IProps> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      ready:false
    };
  }

  public componentDidMount = () => {
    setTimeout(
      () => {
        this.setState({
          ready:true
        });
      },
      100);
  }

  public render(): JSX.Element {
    let heightClass:string = this.props.height ? cssClassCoversionDictionary[this.props.height] : '';
    let color:string = this.props.theme === 'dark' ? '#fff' : '#000';
    let textPlacementClass:string = this.props.textPlacement ?  cssClassCoversionDictionary[this.props.textPlacement] : "center-center";
    let readyClass = this.state.ready ? 'ready' : '';
    let decorativeFontClass = this.props.decorativeText ? "decorative-text" : "";
    return (
      <ScrollFadeIn>
        <div className={'hero '+heightClass+' '+readyClass}>
          <div className={'hero-content '+textPlacementClass}>
            <div className='small-max-width-container'>
              {this.props.icon &&
                <div className='hero-icon'>
                  <img style={{width:'100%'}} src={this.props.icon} alt={this.props.icon} />
                </div>
              }
              {this.props.preTitle &&
                <h5 className='hero-pre-title uppercase full-width' style={{color:color}}>{this.props.preTitle}</h5>
              }
              {this.props.title &&
                <h1 className={'hero-title full-width '+decorativeFontClass} style={{color:color}}>{this.props.title}</h1>
              }
              {this.props.subTitle &&
                <h5 className='hero-subtitle uppercase full-width tiny-padding' style={{color:color}}>{this.props.subTitle}</h5>
              }
              {this.props.description &&
                <p className='hero-description' style={{color:color}}>{this.props.description}</p>
              }
              {this.props.wakeShaperFinder &&
                <div className='hero-component'>
                  {<WakesurfEdgeSelector />}
                </div>
              }
            </div>
          </div>
          <div className={`hero-tint tint ${ this.props.backgroundTint }`} />
          {this.props.backgroundImage &&
            <div className='hero-background' style={{backgroundImage:`url(${ this.props.backgroundImage })`}} />
          }
        </div>
      </ScrollFadeIn>
    );
  }
}

export const cssClassCoversionDictionary = {
  threeQuarter:'three-quarter',
  half:'half',
  quarter:'quarter',
  full:'full',
  centerCenter:'center-center',
  leftCenter:'left-center',
  rightCenter:'right-center',
  bottomLeft:'bottom-left',
  bottomRight:'bottom-right',
  bottomCenter:'bottom-center',
  topLeft:'top-left',
  topRight:'top-right',
  topCenter:'top-center'
};

export default HosportsHero;
